import { useEffect } from 'react';

declare global {
  interface Window {
    __onekoLoaded?: boolean;
  }
}

export default function CatFollower() {
  useEffect(() => {
    // already loaded? bail
    if (window.__onekoLoaded) return;
    if (document.querySelector('script[data-oneko]')) return;

    const script = document.createElement('script');
    script.src = `${process.env.PUBLIC_URL || ''}/oneko.js`;
    script.async = true;
    script.dataset.oneko = 'true'; // mark so we can detect it later
    script.onload = () => {
      window.__onekoLoaded = true;
      console.log('oneko ready 🐱');
    };
    script.onerror = () => console.error('Failed to load /oneko.js');

    document.body.appendChild(script);

    // IMPORTANT: do not remove the script in cleanup; we want it persistent
    return () => {};
  }, []);

  return null;
}
